import React from 'react'
import { GenericError } from '@commutifi-fe/ui'
import { HttpStatusCode } from '@commutifi-fe/constants'

function NotFound() {
  return <GenericError type="page" error={{ status: HttpStatusCode.NotFound }} />
}

export default NotFound
